module.exports = __webpack_public_path__ + "img/icon.bc28b96a.svg";